import { customSortApprovalAmount, customSortApprovedAmount, customSortInvoiceDate, customSortInvoiceNo, customSortPFInvoiceNo, customSortPurchaseDate, genericSort } from "../customSort/customSort";

export const invoiceDataColumns = [
    {
      Header: "No",
      accessor: "no",
    },
    {
      Header: "In No",
      accessor: "inNo",
      sortType:customSortInvoiceNo
    },
    {
      Header: "Proforma No",
      accessor: "pfiNo",
      sortType:customSortPFInvoiceNo
    },
    {
      Header: "Invoice Date",
      accessor: "invoiceDate",
      sortType:customSortInvoiceDate
    },
    {
      Header: "Major Type",
      accessor: "majorType",
      sortType:genericSort
    },
    {
      Header: "Minor Type",
      accessor: "minorType",
      sortType:genericSort
    },
    {
      Header: "Client Name",
      accessor: "clientName",
      sortType:genericSort
    },
    {
      Header: "Approved Amount",
      accessor: "approvedAmount",
      sortType:customSortApprovedAmount
  
    },
    {
      Header: "Received Amount",
      accessor: "receivedAmount"  
    },
    {
      Header: "Invoice",
      accessor: "invoice",    
    },
    {
      Header: "Action",
      accessor: "action",
    },
  ];
  
  export const invoicePendingDataColumns = [
    {
      Header: "No",
      accessor: "no",
    },
    {
      Header: "In No",
      accessor: "inNo",
      sortType:customSortInvoiceNo
    },
    {
      Header: "Proforma No",
      accessor: "pfiNo",
      sortType:customSortPFInvoiceNo
    },
      {
        Header: "Invoice Date",
        accessor: "invoiceDate",
        sortType:customSortInvoiceDate
      },
    {
      Header: "Major Type",
      accessor: "majorType",
      sortType:genericSort
  
    },
    {
      Header: "Minor Type",
      accessor: "minorType",
      sortType:genericSort
  
    },
    {
        Header: "Client Name",
        accessor: "clientName",
        sortType:genericSort
    },
    {
      Header: "Requested Amount",
      accessor: "approvalAmount",
      sortType:customSortApprovalAmount
    },
  
    {
      Header: "Invoice",
      accessor: "invoice",
    },
    {
      Header: "Action",
      accessor: "action",
    },
  ];
  export const invoiceRejectedDataColumns = [
    {
      Header: "No",
      accessor: "no",
    },
    {
      Header: "In No",
      accessor: "inNo",
      sortType:customSortInvoiceNo
    },
    {
      Header: "Proforma No",
      accessor: "pfiNo",
      sortType:customSortPFInvoiceNo
    },
      {
        Header: "Invoice Date",
        accessor: "invoiceDate",
        sortType:customSortInvoiceDate
      },
    {
      Header: "Major Type",
      accessor: "majorType",
      sortType:genericSort
    },
    {
      Header: "Minor Type",
      accessor: "minorType",
      sortType:genericSort
    },
    {
      Header: "Requested Amount",
      accessor: "approvalAmount",
      sortType:customSortApprovalAmount
  
    },
    {
      Header: "Status",
      accessor: "status",
    },
    {
      Header: "Action",
      accessor: "action",
    },
  ];